import { render, staticRenderFns } from "./mo-stacked-accordion.html?vue&type=template&id=efc77572&scoped=true&external"
import script from "./mo-stacked-accordion.ts?vue&type=script&lang=ts&external"
export * from "./mo-stacked-accordion.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-stacked-accordion.vue?vue&type=style&index=0&id=efc77572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc77572",
  null
  
)

export default component.exports